import type { Location, ParametersLocation } from "@/lib/api";

/**
 * Dashboard locations identify an observed station via `parameter_location_id`.
 * The time-series widget fetches `/parameters/locations` and matches that id.
 */
export function resolveObservedStationId(
  dashboardLocation: Location | undefined,
): string | undefined {
  const id = dashboardLocation?.parameter_location_id?.trim();
  return id || undefined;
}

export function findObservedStation(
  stations: ParametersLocation[] | undefined,
  stationId: string | undefined,
): ParametersLocation | undefined {
  if (!stationId || !stations) return undefined;
  return stations.find((station) => station.id === stationId);
}
